import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../../shared';
import { ClientePipeSharedModule } from '../../../pipes';
import { ClienteCentralCompraParticipantePipelineCardComponent } from './cliente-central-compra-participante-pipeline-card.component';


@NgModule({
    imports: [
        SharedModule,
        ClientePipeSharedModule
    ],
    declarations: [
        ClienteCentralCompraParticipantePipelineCardComponent
    ],
    exports: [
        ClienteCentralCompraParticipantePipelineCardComponent
    ]
})
export class ClienteCentralCompraParticipantePipelineCardModule { }
